export default __webpack_public_path__ + "static/onSumShit-cab938d5c8b15bcb13a15671f7b33c7d.jpeg";